<template>
  <div class="promo">
    <div class="flex gap-5 justify-between items-end mb-6 mdmax:flex-col">
      <div class="flex w-full gap-5 mdmax:w-full mdmax:flex-col">
        <div class="w-full max-w-lg mdmax:w-full">
          <label
            class="text-base text-neutral-700 font-medium mb-1 inline-block"
            >Pencarian</label
          >
          <div class="relative">
            <TextField
              type="text"
              :withIcon="true"
              placeholder="Cari promo..."
              v-model="search"
              @enter="onSearch"
            />
            <div class="absolute left-3 top-1/2 transform -translate-y-1/2">
              <Search />
            </div>
          </div>
        </div>
      </div>
      <div>
        <button
          @click="$router.push('/promo/create')"
          class="px-2 py-2 w-32 bg-primary-500 text-white rounded-lg font-medium hover:bg-primary-600 transition-colors"
        >
          + Add Promo
        </button>
      </div>
    </div>
    <div class="bg-white rounded-lg shadow-sm overflow-hidden">
      <div class="overflow-x-auto">
        <table class="w-full text-left border-collapse">
          <thead>
            <tr
              class="bg-neutral-50 text-neutral-500 text-sm font-semibold border-b border-neutral-200"
            >
              <th class="p-4">Nama Promo</th>
              <th class="p-4">Layanan Pengiriman</th>
              <th class="p-4">Periode</th>
              <th class="p-4">Diskon</th>
              <th class="p-4">Kuota</th>
              <th class="p-4">Status</th>
              <th class="p-4">Action</th>
            </tr>
          </thead>
          <tbody class="text-neutral-700 text-sm">
            <tr
              v-for="promo in items"
              :key="promo.id"
              class="border-b border-neutral-100 hover:bg-neutral-50 transition-colors"
            >
              <td class="p-4 font-medium">{{ promo.name }}</td>
              <td class="p-4 flex items-center gap-2">
                <img
                  v-if="promo.delivery_service && promo.delivery_service.logo"
                  :src="promo.delivery_service.logo"
                  alt="logo"
                  class="w-6 h-6 object-contain"
                />
                {{ promo.delivery_service ? promo.delivery_service.name : "-" }}
              </td>
              <td class="p-4">
                {{ formatDate(promo.start_date) }} -
                {{ formatDate(promo.end_date) }}
              </td>
              <td class="p-4">{{ promo.discount_percentage }}%</td>
              <!-- Use available_quota if present, otherwise default logic or verify requirement -->
              <td class="p-4">
                {{ promo.available_quota }} / {{ promo.quota }}
              </td>
              <td class="p-4">
                <span
                  class="px-2 py-1 rounded text-xs font-medium"
                  :class="statusClass(promo.status)"
                >
                  {{ promo.status }}
                </span>
              </td>
              <td class="p-4">
                <div class="flex items-center gap-3">
                  <button
                    @click="onEdit(promo)"
                    class="text-neutral-500 hover:text-primary-500 transition-colors"
                  >
                    <Pencil width="18" height="18" />
                  </button>
                  <button
                    @click="onDelete(promo)"
                    class="text-neutral-500 hover:text-red-500 transition-colors"
                  >
                    <Trash width="18" height="18" />
                  </button>
                </div>
              </td>
            </tr>
            <tr v-if="!items || items.length === 0">
              <td colspan="7" class="p-4 text-center text-neutral-500">
                Data tidak ditemukan!
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
    <div
      class="text-neutral-500 font-medium mt-2 text-sm"
      v-if="!isMobile && items.length > 0"
    >
      Menampilkan {{ (page - 1) * limit + 1 }} -
      {{ Math.min(page * limit, meta.total_item) }} dari {{ meta.total_item }}
    </div>
    <div
      class="mt-8 flex justify-end items-center mb-6"
      v-if="items.length > 0"
    >
      <pagination
        :currentPage="page"
        :totalCount="meta.total_item"
        :pageSize="limit"
        @onPageChange="changePage"
      />
    </div>

    <Modal
      :modalVisible="deleteModalVisible"
      @close="closeDeleteModal"
      width="400px"
    >
      <div slot="modal-content" class="text-center">
        <h3 class="text-lg font-bold text-neutral-800 mb-2">Hapus Promo</h3>
        <p class="text-neutral-600 mb-6">
          Apakah Anda yakin ingin menghapus promo
          <strong>{{ promoToDelete ? promoToDelete.name : "" }}</strong
          >?
        </p>
        <div class="flex justify-center gap-3">
          <button
            @click="closeDeleteModal"
            class="px-4 py-2 rounded-lg border border-neutral-300 text-neutral-600 hover:bg-neutral-50 font-medium"
          >
            Batal
          </button>
          <button
            @click="confirmDelete"
            class="px-4 py-2 rounded-lg bg-red-500 text-white hover:bg-red-600 font-medium"
          >
            Hapus
          </button>
        </div>
      </div>
    </Modal>
  </div>
</template>

<script>
import { mapActions, mapGetters } from "vuex"
import dayjs from "dayjs"

export default {
  name: "PromoList",
  components: {
    TextField: () => import("@/components/Forms/TextField"),
    Pagination: () => import("@/components/Pagination/Pagination"),
    Search: () => import("@/components/Icons/Search"),
    Pencil: () => import("@/components/Icons/Pencil"),
    Trash: () => import("@/components/Icons/Trash"),
    Modal: () => import("@/components/Modal/Modal")
  },
  data: () => ({
    search: "",
    page: 1,
    limit: 10,
    timer: null,
    deleteModalVisible: false,
    promoToDelete: null
  }),
  computed: {
    ...mapGetters("promo", ["promoList"]),
    ...mapGetters("common", ["isMobile"]),
    meta() {
      return this.promoList.meta || { total_page: 1, total_item: 0 }
    },
    items() {
      return this.promoList.data || []
    }
  },
  methods: {
    ...mapActions("promo", ["getPromos", "deletePromo"]),
    ...mapActions("common", ["showLoading", "hideLoading", "showExactToast"]),

    formatDate(date) {
      if (!date) return "-"
      const rawDate = typeof date === "string" ? date.replace("Z", "") : date
      return dayjs(rawDate).format("DD MMM YYYY HH:mm")
    },
    statusClass(status) {
      if (status === "Active") return "bg-green-100 text-green-700"
      return "bg-gray-100 text-gray-700"
    },
    fetchPromos() {
      this.showLoading()
      const params = {
        page: this.page,
        per_page: this.limit,
        search_keyword: this.search
      }
      this.getPromos({ params })
        .catch((err) => console.error(err))
        .finally(() => this.hideLoading())
    },
    onSearch() {
      if (this.timer) clearTimeout(this.timer)
      this.timer = setTimeout(() => {
        this.page = 1
        this.fetchPromos()
      }, 500)
    },
    changePage(val) {
      this.page = val
      this.fetchPromos()
    },
    onEdit(promo) {
      this.$router.push(`/promo/edit/${promo.id}`)
    },
    onDelete(promo) {
      this.promoToDelete = promo
      this.deleteModalVisible = true
    },
    closeDeleteModal() {
      this.deleteModalVisible = false
      this.promoToDelete = null
    },
    async confirmDelete() {
      if (!this.promoToDelete) return

      this.showLoading()
      try {
        await this.deletePromo({ id: this.promoToDelete.id })
        this.showExactToast({
          message: "Promo berhasil dihapus",
          type: "success"
        })
        this.fetchPromos()
      } catch (error) {
        console.error(error)
        this.showExactToast({
          message: error.response?.data?.message || "Gagal menghapus promo",
          type: "error"
        })
      } finally {
        this.hideLoading()
        this.closeDeleteModal()
      }
    }
  },
  mounted() {
    this.fetchPromos()
  }
}
</script>

<style lang="scss" scoped>
.promo {
  &::v-deep .vs__search {
    padding-top: 0.5rem;
    padding-bottom: 0.5rem;
    padding-left: 0.75rem;
    padding-right: 0.75rem;
    border-radius: 0.5rem;
  }
}
</style>
